import { Component, ElementRef, OnChanges, inject, input, signal } from '@angular/core';
import { ResponsiveSize } from '@shared/helper/responsive-sizes';
import { GeneralService } from '@shared/services/general.service';

@Component({
  selector: 'app-image-generator',
  templateUrl: './image-generator.component.html',
  styleUrls: ['./image-generator.component.scss'],
})
export class ImageGeneratorComponent implements OnChanges {
  src = input.required<string>();
  name = input<string>();
  imageType = input<'portrait' | 'landscape' | 'full_land' | 'square' | 'original'>('portrait');
  sizes = input<ResponsiveSize>();
  noBlurPlaceholder = input(false);
  srcsetArr = signal<[string, string][]>([]);
  blurStyle = signal('');
  shouldRender = signal(false);
  imageLoaded = signal(false);
  private intersectionObserver: IntersectionObserver | null = null;
  private hostRef: ElementRef;

  generalService = inject(GeneralService);

  constructor(hostRef: ElementRef) {
    this.hostRef = hostRef;
  }

  ngOnChanges() {
    this.srcsetArr.set([]);
    if (this.sizes()) {
      let extension;
      if (this.src().split('.').pop() === 'jpg') {
        extension = 'jpeg';
      } else {
        extension = 'png';
      }
      for (const size of this.sizes()!) {
        const sizeArr = [];
        if (size[0]) sizeArr.push(`(min-width:${size[0] - 1}px)`);
        if (size[1]) sizeArr.push(`(max-width:${size[1]}px)`);
        const firstItem = sizeArr.join(' and ');

        this.srcsetArr.update((items) => [
          ...items,
          [firstItem, `${this.src()}?imgProcess=pr:fwebp:w${size[2]}`],
          [firstItem, `${this.src()}?imgProcess=pr:f${extension}:w${size[2]}`],
        ]);

        if (!this.noBlurPlaceholder()) {
          this.blurStyle.set(
            `background-image: url('${this.src()}?imgProcess=pr:w500:bl10:fjpeg');`,
          );
        }
      }
    }
  }

  ngAfterViewInit() {
    if (this.generalService.isBrowserOnly) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.shouldRender.set(true);
        }
      });
      this.intersectionObserver.observe(this.hostRef.nativeElement);
    }
  }

  ngOnDestroy() {
    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.hostRef.nativeElement);
      this.intersectionObserver = null;
    }
  }

  handleImageLoad() {
    this.imageLoaded.set(true);
  }
}
